import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

import { METRIC_FILTER_OPTIONS } from 'app/hub-components/constants/query-filter.constants';
import { Connective, IMetricFilterWrapper } from 'app/hub-components/interfaces/query-filter.interface';
import { ROOT_CONNECTIVE, rootConnective } from 'app/hub-components/utils/filter.util';
import { Query } from '../../../../models/analytics-api/query.model';
import { Metric, Schema } from '../../../../models/analytics-api/schema.model';
import { QueryFilterOption } from '../../../../models/query-option.model';
import { TrackingService } from '../../../../services/tracking/tracking.service';

@Component({
  selector: 'metric-filters-modal',
  templateUrl: './metric-filters-modal.component.html',
  styleUrls: ['./metric-filters-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class MetricFiltersModalComponent implements OnInit {
  @Input() query: Query;
  @Input() schema: Schema;
  @Input() compatibleMetrics: Metric[];
  @Input() supportedRollups?: string[];
  @Output() modalMetricFiltersClosed = new EventEmitter<object>();

  public datasetName: string;
  public interval: string;
  public filters: IMetricFilterWrapper[];
  public connective: Connective = ROOT_CONNECTIVE;
  public metricFilterOptions: QueryFilterOption[] = [];
  public emptyFilterExists: boolean = false;
  public infoMessage = [{ severity: 'info', detail: 'Metric filtered rows will show N/A as metric values if you use a Sum By other than Total.' }];

  private updatedMetricFilters: IMetricFilterWrapper[];
  private updatedConnective: Connective = ROOT_CONNECTIVE;

  constructor(
    private trackingService: TrackingService,
  ) {}

  public ngOnInit(): void {
    this.datasetName = this.query.dataset;
    this.filters = this.query.metricFilters || [];
    this.connective = rootConnective(this.query.metricFilters);
    this.updatedConnective = this.connective;

    this.interval = this.query.interval;
    this.metricFilterOptions = METRIC_FILTER_OPTIONS;

    if (this.supportedRollups && !this.supportedRollups.includes('total')) {
      this.infoMessage = [{ severity: 'info', detail: 'Metric filtered rows will show N/A as metric values.' }];
    }
  }

  public updateFilters(data) {
    this.updatedMetricFilters = data.filters;
    this.updatedConnective = data.connective;
    this.emptyFilterExists = data.emptyFilterWarnings.flat().find(value => value === true);
  }

  public applyFilters(): void {
    this.trackingService.track('Add metric filter and run query');
    const runQuery = this.hasMetrics;
    if (!!this.updatedMetricFilters) {
      this.query.metricFilters = this.updatedMetricFilters;
      this.query.metricFilters.connective = this.updatedConnective;
      this.query.metricFilters.forEach(filter => {
        filter.expressions.forEach(expression => {
          if (expression?.type) {
            const filterType = this.metricFilterOptions.find(mfo => mfo.type === expression.type);
            if (filterType) {
              this.trackingService.track('Apply metric filter', { value: filterType.name });
            }
          }
        });
      });
      this.modalMetricFiltersClosed.emit({ runQuery: runQuery });
    }
  }

  public cancel() {
    this.modalMetricFiltersClosed.emit({ runQuery: false });
  }

  public get hasMetrics(): boolean {
    return !!this.query.metrics.length;
  }
}
